import { FormElementType } from "~/api";

export const nonQuestionElements: FormElementType[] = [
  FormElementType.ANSWER_REVIEW,
  FormElementType.ACTION_BUTTON,
  FormElementType.FORM_TEXT,
  FormElementType.HEADING,
  FormElementType.SECTION,
  FormElementType.NAME_STAMP,
  FormElementType.CHANGE_STATUS_BUTTON,
  FormElementType.LINKED_ANSWER,
  FormElementType.COMPLIANCE_ITEM,
  FormElementType.DIVIDER,
  FormElementType.WORKFLOW_ASSOCIATION,
];
